<app-header></app-header>
<app-lateral-buttons></app-lateral-buttons>
<section id="consulta">
  <div class="container" style="max-width: 1300px !important;">
    <div class="row">
      <div class="col-md-12">
        <h2 class="wow fadeInUp">Consulta de Productos</h2>
      </div>
      <div class="col-md-6">
        <form class="consulta">
          <div class="form-group cl-white">
            <label for="tipodocumento">Tipo documento</label>
            <select class="form-control" [(ngModel)]="selectedItem" [ngModelOptions]="{standalone: true}"
              >
              <option disabled selected> Seleccione el tipo de documento</option>
              <option value="1">C.C</option>
              <option value="2">C.E</option>
              <option value="3">NIT</option>
            </select>
          </div>
          <div class="form-group cl-white">
            <label for="identificación">Identificación</label>
            <input type="text" class="form-control" placeholder="Ingresa el número de identificación"
              [(ngModel)]="identificationItem" [ngModelOptions]="{standalone: true}">
          </div>
          <button style="    border-radius: 18px;" class="btn btn-general btn-white" role="button" (click)="getPendingPayments()">
            <i fa fa-right-arrow></i>Consultar
          </button>
        </form>
      </div>
      <div class="col-md-12">
        <form class="consulta">
        <label class="cliente" *ngIf="showTable"> Señor {{nombreDeudor}} sus deudas actuales son:</label>
        <div *ngIf="showTable" style="overflow-x: scroll;">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="display: none;"><b>Comercio</b></th>
                <th style="display: none;"><b>Producto</b></th>
                <th><b>Referencia</b></th>
                <th><b>N° Creditos</b></th>
                <th style="display: none;"><b>N° Cuotas</b></th>
                <th><b>Valor Cuota Mes</b></th>
                <th><b>Valor Pago Total</b></th>
                <th style="display: none;"><b>Fecha Límite</b></th>
                <th ><b>Extracto</b></th>
                <th ><b>Pago</b></th>
                <th ><b></b></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pendingPayments; let i = index">
                <td style="display: none;">{{item.comercio}}</td>
                <td style="display: none;">{{item.producto}}</td>
                <td>{{item.referencia}}</td>
                <td>{{item.creditos }}</td>
                <td style="display: none;">{{item.cuotas }}</td>
                <td>{{"$ " + (item.valorCuotaMes  | number)}}</td>
                <td>{{"$ " + (item.valorPagoTotal  | number) }}</td>
                <td style="display: none;">{{item.fechaLimitePago  | date:'dd/MM/yyyy'}}</td>
                <td > <button style="    border-radius: 18px;" class="btn btn-general btn-white" role="button" (click)="getExtracto(item)">
                  <i class="fa fa-fw fa-download"></i>
                </button></td>
                <td>
                  <input type="radio" [id]="'radio1' + item.creditos " name="group" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}" [value]="'opcion1' + item.creditos ">
                  <label [for]="'radio1' + item.creditos " style="padding-left: 10px;">Para Pago Mínimo</label>
                  <br>
                  <input type="radio" [id]="'radio2' + item.creditos " name="group" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone: true}" [value]="'opcion2' + item.creditos ">
                  <label [for]="'radio2' + item.creditos " style="padding-left: 10px;">Para Pago Parcial (Abono) o pago total</label>
                </td>
                <td>
                  <button style="border-radius: 18px;" class="btn btn-general btn-white" role="button" (click)="pagar()">
                    Pagar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        </form>
      </div>

    </div>
  </div>
</section>
<app-footer></app-footer>
